export default __webpack_public_path__ + "static/media/s.6bca0593.jpg";